export default "__VITE_ASSET__Cto6vYCB__"